<template>
  <div
    :class="className"
    :style="style"
    @mousedown.stop="startDrag"
    @dblclick="startEditText"
  >
    <div class="rotate" @mousedown.stop="startRotate">
      <div class="angle" v-show="rotating">
        {{ (selected.rotate || 0).toFixed(1) }}°
      </div>
      <img src="../../assets/images/rotate.svg" />
    </div>
    <div class="remove" @click="remove">
      <img src="../../assets/images/delete.svg" />
    </div>
    <!--<div class="cube n" @mousedown.stop="startScale('n',$event)"></div>-->
    <!--<div class="cube ne" @mousedown.stop="startScale('ne',$event)"></div>-->
    <div class="cube e" @mousedown.stop="startScale('e', $event)"></div>
    <div class="cube se" @mousedown.stop="startScale('se', $event)"></div>
    <div class="cube s" @mousedown.stop="startScale('s', $event)"></div>
    <div class="cube sw" @mousedown.stop="startScale('sw', $event)"></div>
    <div class="cube w" @mousedown.stop="startScale('w', $event)"></div>
    <div class="cube nw" @mousedown.stop="startScale('nw', $event)"></div>
    <div class="position" v-show="moving">
      {{ Math.round((selected.x || 0) - selected.width / 2) }},{{
        Math.round((selected.y || 0) - selected.height / 2)
      }}
    </div>
    <div
      class="editor"
      ref="text"
      contenteditable="plaintext-only"
      @mousedown.stop="
        {
        }
      "
      @keydown.enter.prevent="updateTextContent"
      @blur="updateTextContent"
    ></div>
  </div>
</template>

<script>
import keyboardJS from 'keyboardjs';
export default {
  data() {
    return {};
  },
  computed: {
    selected() {
      return this.$store.state.selected;
    },
    canvas() {
      return this.$store.state.canvas;
    },
    scaleRate() {
      return this.$store.state.scaleRate;
    },
    moving() {
      return this.$store.state.moving;
    },
    rotating() {
      return this.$store.state.rotating;
    },
    editing() {
      return this.$store.state.editing;
    },
    style() {
      if (this.selected && this.selected.id) {
        // const mask = this.temp_mask || this.mask
        // const ids = this.mask.id.split("-")
        // const rotate = mask.rotate
        const width = this.selected.width * this.scaleRate;
        const height = this.selected.height * this.scaleRate;
        return {
          // zIndex: parseInt(ids[ 0 ]) * 100 + parseInt(ids[ 1 ]) * 10 + 1,
          transform: 'rotate(' + this.selected.rotate + 'deg)',
          zIndex: this.selected.zIndex,
          left:
            (this.selected.x - this.selected.width / 2) * this.scaleRate + 'px',
          top:
            (this.selected.y - this.selected.height / 2) * this.scaleRate +
            'px',
          width: Math.max(width, 10) + 'px',
          height: height === 'auto' ? 'auto' : Math.max(height, 10) + 'px'
        };
      } else {
        return {
          display: 'none'
        };
      }
    },
    className() {
      const rotate = ['', 'sw', 'w', 'nw', 'n', 'ne', 'e', 'se', 's'];
      let className = ['selection-box'];
      if (this.editing) {
        className.push('editing');
      }
      if (this.moving) {
        className.push('moving');
      }
      if (this.rotating) {
        className.push('rotating');
      }
      let rotateClass =
        rotate[Math.floor((this.selected.rotate + 22.5 + 180) / 45)];
      className.push(rotateClass);
      return className.join(' ');
    }
  },
  methods: {
    startDrag(e) {
      const x =
        this.selected.x + e.offsetX / this.scaleRate - this.selected.width / 2;
      const y =
        this.selected.y + e.offsetY / this.scaleRate - this.selected.height / 2;
      const position = this.canvas.findIndex(
        item => item.id === this.selected.id
      );
      let to_selected = null;
      for (let i = position + 1; i < this.canvas.length; i++) {
        const comp = this.canvas[i];
        const center = {
          x: comp.x,
          y: comp.y
        };
        const angle = (-comp.rotate * Math.PI) / 180;
        //旋转点到矩形的坐标系
        let x0 =
          (x - center.x) * Math.cos(angle) -
          (y - center.y) * Math.sin(angle) +
          center.x;
        let y0 =
          (x - center.x) * Math.sin(angle) +
          (y - center.y) * Math.cos(angle) +
          center.y;
        if (
          x0 >= comp.x - comp.width / 2 &&
          y0 >= comp.y - comp.height / 2 &&
          x0 <= comp.x + comp.width / 2 &&
          y0 <= comp.y + comp.height / 2
        ) {
          to_selected = i;
        }
      }

      if (this.canvas[to_selected]) {
        this.$store.dispatch('elm_select', {
          id: this.canvas[to_selected].id
        });
      } else {
        this.$store.dispatch('elm_start_drag', {
          id: this.selected.id,
          event: e
        });
      }
    },
    startRotate(e) {
      this.$store.dispatch('elm_start_rotate', {
        id: this.selected.id,
        event: e
      });
    },
    startScale(type, e) {
      this.$store.dispatch('elm_start_scale', {
        id: this.selected.id,
        event: e,
        type
      });
    },
    startEditText() {
      keyboardJS.pause();
      if (
        this.selected.type !== 'text' &&
        this.selected.type !== 'title' &&
        this.selected.type !== 'digest' &&
        this.selected.type !== 'advertuser'
      )
        return false;
      this.$store.dispatch('elm_start_edit_text', {
        id: this.selected.id
      });
      this.$nextTick(() => {
        const elm = this.$refs.text;
        const comp = this.canvas.find(item => item.id === this.selected.id);
        elm.innerText = comp.content;
        elm.style = comp.style;
        elm.style.fontSize =
          comp.style.fontSize * this.$store.state.scaleRate + 'px';
        const range = document.createRange();
        range.selectNodeContents(elm);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      });
    },
    updateTextContent() {
      if (!this.editing) return false;
      const elm = this.$refs.text;
      this.$store.dispatch('elm_complete_edit_text', {
        data: {
          content: elm.innerText
        }
      });
    },
    remove() {
      this.$store.commit('elm_remove', {
        id: this.selected.id
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../stylesheets/base';

// prettier-ignore
$dir: (n, ne, e, se, s, sw, w, nw, n, ne, e, se, s, sw, w, nw, n, ne, e, se, s, sw, w, nw);
// prettier-ignore
$map: (0:0, 1:1, 2:2, 3:3, 4:4, 5:5, 6:6, 7:7, 8:8, 9:9);

@function number($string) {
  @return map-get($map, $string);
}

.selection-box {
  position: absolute;
  border: 1px solid $green;
  cursor: move;
  top: 9999px;
  box-sizing: border-box;
  z-index: $baseIndex + 1100;

  .editor {
    width: 100%;
    height: 100%;
    display: none;
    user-modify: read-write-plaintext-only;
    white-space: nowrap;
    cursor: text;
  }

  &.editing {
    .editor {
      display: block;
      outline: none;
    }
  }

  .position {
    color: #ffffff;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    right: -5px;
    bottom: 0;
    transform: translateX(100%);
    font-size: 12px;
    padding: 0 3px;
    border-radius: 2px;
  }

  @for $x from 1 through 8 {
    $type1: nth($dir, $x);
    &.#{$type1} {
      > .cube {
        @for $i from 1 through 8 {
          $type2: nth($dir, $i);
          &.#{$type2} {
            width: $x + $i;
            $type3: nth($dir, $x + $i - 1);
            cursor: #{$type3}-resize;
          }
        }
      }
    }
  }
  &.rotating {
    opacity: 0.5;
    .cube {
      display: none;
    }
  }
  &.moving,
  &.editing {
    .cube,
    .rotate {
      display: none;
    }
  }
  &.moving {
    opacity: 0.5;
  }

  > .remove,
  > .rotate {
    user-select: none;
    > img {
      position: absolute;
      left: 50%;
      top: 50%;
      pointer-events: none;
      @include transform(translate(-50%, -50%));
    }
  }

  > .remove {
    cursor: pointer;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $green;
    color: #fff;
    text-align: center;
    line-height: 16px;
    position: absolute;
    top: -8px;
    right: -8px;
  }

  > .rotate {
    cursor: pointer;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $green;
    position: absolute;
    top: -8px;
    left: 50%;
    @include transform(translateX(-50%));
    .angle {
      position: absolute;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.4);
      transform: translate(-50%, -20px);
      left: 50%;
      top: 0;
      font-size: 12px;
      padding: 0 3px;
      border-radius: 2px;
    }
  }
  > .cube {
    width: 10px;
    height: 10px;
    position: absolute;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;
    &.n {
      top: -6px;
      left: 50%;
      @include transform(translateX(-50%));
    }
    &.s {
      bottom: -6px;
      left: 50%;
      @include transform(translateX(-50%));
    }
    &.w {
      top: 50%;
      left: -6px;
      @include transform(translateY(-50%));
    }
    &.e {
      top: 50%;
      right: -6px;
      @include transform(translateY(-50%));
    }
    &.ne {
      right: -6px;
      top: -6px;
    }
    &.nw {
      left: -6px;
      top: -6px;
    }
    &.se {
      right: -6px;
      bottom: -6px;
    }
    &.sw {
      left: -6px;
      bottom: -6px;
    }
  }
  > .handle {
    position: absolute;
    right: -20px;
    top: -20px;
    padding-top: 15px;
    padding-right: 15px;
    > .icon-rotate {
      display: block;
      font-size: 20px;
      background-color: #fff;
      color: $green;
      border-radius: 50%;
    }
  }
}
</style>
